import { breakpoints } from '../mediaStyles';

const useIsMobileDisplay = () => {
  return window.innerWidth < breakpoints.tablet;
};

export default useIsMobileDisplay;
